import { render, staticRenderFns } from "./AppealsWrapper.vue?vue&type=template&id=5e67bae5&"
import script from "./AppealsWrapper.vue?vue&type=script&lang=js&"
export * from "./AppealsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports